export const AUTH_BOOT_TIMEOUT_MS = 12000;

export class AuthBootstrapTimeoutError extends Error {
  constructor(label, timeoutMs) {
    super(`${label} timed out after ${timeoutMs}ms`);
    this.name = "AuthBootstrapTimeoutError";
    this.code = "AUTH_BOOT_TIMEOUT";
    this.label = label;
    this.timeoutMs = timeoutMs;
  }
}

export function withAuthBootstrapTimeout(promise, label, timeoutMs = AUTH_BOOT_TIMEOUT_MS) {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(
      () => reject(new AuthBootstrapTimeoutError(label, timeoutMs)),
      timeoutMs,
    );
  });

  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
}

export async function runAuthBootstrapStep(operation, label, options = {}) {
  const timeoutMs = options.timeoutMs ?? AUTH_BOOT_TIMEOUT_MS;
  const retries = options.retries ?? 1;
  let lastError;

  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      return await withAuthBootstrapTimeout(operation(), label, timeoutMs);
    } catch (error) {
      lastError = error;
      if (attempt >= retries) {
        throw error;
      }
    }
  }

  throw lastError;
}
